import actions from '../actions/carouselActions';
import createReducer from '../utils/createReducer';
import CarouselRecord from '../records/carouselRecord';

const initialState = new CarouselRecord();

const actionHandlers = {
    [actions.CHANGE_IMAGE_INDEX](state, {payload = {newIndex: 0, prevIndex: 1}}) {
        return state.merge({
            index: payload.newIndex,
            prevIndex: payload.newPrevIndex
        });
    },

    [actions.SET_FULL_SCREEN_STATE](state, {payload = {newFullScreen: true}}) {
        return state.merge({
            fullScreen: payload.newFullScreen
        });
    },

    [actions.SET_VERTICAL_GALLERY_OPEN_STATE]:
        (state, {payload = {isOpen: true}}) => state.merge({
            isVerticalGalleryOpen: payload.isOpen,
            ...(payload.index ? {index: payload.index} : {})
        })
};

export default createReducer(actionHandlers, initialState);
